var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewQuoteStatusIcon = function SvgNewQuoteStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#50B5FF",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50B5FF",
    stroke: "#50B5FF",
    strokeWidth: 0.3,
    d: "M26.403 27.403H23.38a.58.58 0 0 0-.402.163l-.001.002a.61.61 0 0 0 0 .864l.004.004a.56.56 0 0 0 .39.151h3.04l-.016 3.024a.56.56 0 0 0 .173.412h-.001l-.165-4.62Zm0 0v-3.007a.6.6 0 0 1 .039-.224l-.04 3.23Zm4.226.16a.42.42 0 0 1 .287.11.46.46 0 0 1 0 .653l.11.102-.002.002a.57.57 0 0 1-.422.183l-3.005-.015v3.013l-.009-4.198v.15h3.04Zm0 0v-.15h-.002zm-3.303-3.48.106-.105v-.001l-.002-.001zm0 0a.42.42 0 0 1 .128.304l-.78-.303a.46.46 0 0 1 .652 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50B5FF",
    fillRule: "evenodd",
    d: "M18 20a4 4 0 0 1 4-4h8.343a4 4 0 0 1 2.829 1.172l1.656 1.656A4 4 0 0 1 36 21.657V34a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4zm16 3v11a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h7v2a3 3 0 0 0 3 3zm-.11-2a2 2 0 0 0-.476-.757l-1.657-1.657A2 2 0 0 0 31 18.11V20a1 1 0 0 0 1 1z",
    clipRule: "evenodd"
  })));
};
export { SvgNewQuoteStatusIcon as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/QuoteStatus/assets/new-quote-status-icon.96265e785b1baac77f8ec6125c38ce66.svg";